import { FetcherResult } from "../api-client/fetcher";
import { ModifiedSWRResponse, useSwrGet } from "../api-client/useSwrGet";

type HunterTireDetailsResult = ModifiedSWRResponse<
  FetcherResult<HunterTireDetailsResponse>,
  HunterTireDetailsResponse
>;

export const useGetHunterTireDetails = (
  id: null | number,
): HunterTireDetailsResult => {
  const { data, ...rest } = useSwrGet<HunterTireDetailsResponse>(
    id ? "/retailSiteWebService/parts/tire/hunter/details.php" : null,
    id ? { id: String(id) } : undefined,
    {
      revalidateIfStale: true,
    },
  );

  return {
    data,
    ...rest,
  };
};

export type HunterTireDetailsResponse = unknown;
